"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireDefault(require("react"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Spinner = function Spinner(_ref) {
  var Icon = _ref.icon,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "gray" : _ref$backgroundColor,
      width = _ref.width,
      height = _ref.height;
  if (Icon) return Icon;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("style", null, "\n      .assetcrush-lds-roller div:after {\n        content: \" \";\n        display: block;\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background: ".concat(backgroundColor, ";\n        margin: -4px 0 0 -4px;\n      }\n      ")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      transform: "".concat(width < height ? "scale(".concat(height > 100 ? 1 : height / 300, ",").concat(height > 100 ? 1 : height / 300, ")") : "scale(".concat(width > 100 ? 1 : width / 300, ",").concat(width > 100 ? 1 : width / 300, ")"))
    },
    className: "assetcrush-lds-roller"
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null)));
};

exports.Spinner = Spinner;